import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/hooks/useTranslation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMap,
  faPlus,
  faSearch,
  faUsers,
  faMountain,
  faWater,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import LandingPageStyled from "./LandingPageStyled";

const LandingPage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <LandingPageStyled>
      {/* Header minimalista para la landing page */}
      <header className="landing-header">
        <div className="landing-header__content">
          <div className="landing-header__logo">
            <span className="landing-header__logo-text">DSF</span>
            <span className="landing-header__sublogo">{t("app.title")}</span>
          </div>
          <div className="landing-header__actions">
            <Link
              to="/login"
              className="landing-header__link landing-header__link--login"
            >
              {t("navigation.login")}
            </Link>
          </div>
        </div>
      </header>

      <section className="hero">
        <div className="hero__content">
          <h1 className="hero__title">{t("landing.hero.title")}</h1>
          <p className="hero__subtitle">{t("landing.hero.subtitle")}</p>
          <div className="hero__actions">
            <Link to="/home" className="hero__button hero__button--primary">
              {t("landing.hero.exploreButton")}
            </Link>
            <Link to="/map" className="hero__button hero__button--secondary">
              <FontAwesomeIcon icon={faMap} />
              {t("landing.hero.mapButton")}
            </Link>
          </div>
        </div>
        <div className="hero__visual">
          <div className="hero__icons">
            <FontAwesomeIcon
              icon={faMountain}
              className="hero__icon hero__icon--mountain"
            />
            <FontAwesomeIcon
              icon={faWater}
              className="hero__icon hero__icon--water"
            />
            <FontAwesomeIcon
              icon={faHome}
              className="hero__icon hero__icon--home"
            />
          </div>
        </div>
      </section>

      <section className="features">
        <h2 className="features__title">{t("landing.features.title")}</h2>
        <div className="features__grid">
          <div className="feature">
            <div className="feature__icon">
              <FontAwesomeIcon icon={faSearch} />
            </div>
            <h3 className="feature__title">
              {t("landing.features.discover.title")}
            </h3>
            <p className="feature__description">
              {t("landing.features.discover.description")}
            </p>
          </div>

          <div className="feature">
            <div className="feature__icon">
              <FontAwesomeIcon icon={faMap} />
            </div>
            <h3 className="feature__title">
              {t("landing.features.map.title")}
            </h3>
            <p className="feature__description">
              {t("landing.features.map.description")}
            </p>
          </div>

          <div className="feature">
            <div className="feature__icon">
              <FontAwesomeIcon icon={faPlus} />
            </div>
            <h3 className="feature__title">
              {t("landing.features.contribute.title")}
            </h3>
            <p className="feature__description">
              {t("landing.features.contribute.description")}
            </p>
          </div>

          <div className="feature">
            <div className="feature__icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <h3 className="feature__title">
              {t("landing.features.community.title")}
            </h3>
            <p className="feature__description">
              {t("landing.features.community.description")}
            </p>
          </div>
        </div>
      </section>

      <section className="categories">
        <h2 className="categories__title">{t("landing.categories.title")}</h2>
        <div className="categories__grid">
          <div className="category">
            <FontAwesomeIcon icon={faWater} className="category__icon" />
            <h3 className="category__title">
              {t("landing.categories.water.title")}
            </h3>
            <p className="category__description">
              {t("landing.categories.water.description")}
            </p>
          </div>

          <div className="category">
            <FontAwesomeIcon icon={faHome} className="category__icon" />
            <h3 className="category__title">
              {t("landing.categories.constructions.title")}
            </h3>
            <p className="category__description">
              {t("landing.categories.constructions.description")}
            </p>
          </div>

          <div className="category">
            <FontAwesomeIcon icon={faMountain} className="category__icon" />
            <h3 className="category__title">
              {t("landing.categories.territory.title")}
            </h3>
            <p className="category__description">
              {t("landing.categories.territory.description")}
            </p>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="cta__content">
          <h2 className="cta__title">{t("landing.cta.title")}</h2>
          <p className="cta__description">{t("landing.cta.description")}</p>
          <Link to="/home" className="cta__button">
            {t("landing.cta.button")}
          </Link>
        </div>
      </section>
    </LandingPageStyled>
  );
};

export default LandingPage;
